import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Menu from './components/Menu';
import About from './components/About';
import Membership from './components/Membership';
import JoinXaoDao from './components/JoinXaoDao';
import GovernanceProcess from './components/GovernanceProcess';
import Proposals from './components/Proposals';
import Grants from './components/Grants';
import Faq from './components/Faq';
import Contact from './components/Contact';
import StayConnectedFooter from './components/StayConnectedFooter';
import Announcements from './components/Announcements';
import './index.css';
import NewChapter from './components/NewChapter';

function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <Menu />
      <About />
      <Membership />
      <JoinXaoDao />
      <GovernanceProcess />
      <Proposals />
      <Grants />
      <Faq />
      <NewChapter />
      {/* <Contact /> */}
      <StayConnectedFooter />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/announcements" element={<Announcements />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
